import {styled} from '@linaria/react';
import React from 'react';
import {COLORS} from '../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';
import {LegalEntry} from '../../../types/Entry';
import {UnstyledButton} from '../../atoms/Buttons/UnstyledButton';
import {Text} from '../../atoms/Text/Text';
import {UnstyledLinkLinaria} from '../../atoms/UnstyledLink/UnstyledLinkLinaria';

interface LegalLinksProps {
  copyrightText: string;
  links: LegalEntry[];
  className?: string;
}

export const LegalLinks: React.FC<LegalLinksProps> = ({
  links,
  copyrightText,
  className,
}) => {
  return (
    <Wrapper className={className} data-testid="legalLinks">
      <LinksWrapper>
        {links.map((item, index) => {
          if (!item.href) {
            return (
              <TextButton onClick={item.onClick} key={index}>
                {item.label}
              </TextButton>
            );
          }

          return (
            <LinkItem to={item.href} key={index}>
              {item.label}
            </LinkItem>
          );
        })}
      </LinksWrapper>
      <StyledText dangerouslySetInnerHTML={{__html: copyrightText}} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 1.5rem;
  background-color: ${COLORS.Grey4};
  padding: 1rem;
  display: flex;
  flex-direction: column;
`;

const LinksWrapper = styled.nav`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 0.5rem;
`;

const StyledText = styled(Text)`
  display: block;
  color: ${COLORS.Grey1};
  text-align: center;
  font-size: ${FONT_SIZES.px12};
  a {
    color: ${COLORS.Grey1};
    cursor: pointer;
  }
`;

const linkCss = `
  display: inline;
  font-size: ${FONT_SIZES.px12};
  font-weight: ${FONT_WEIGHTS.mediumBold};
  margin: 0.5rem 1rem;
`;

const LinkItem = styled(UnstyledLinkLinaria)`
  ${linkCss}
`;

const TextButton = styled(UnstyledButton)`
  ${linkCss}
`;
